import Home from '../../views/mHome.vue'

export const mobileRoutes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  }
]
